import React, { useState, useEffect} from 'react';
import { getCityDetails } from '../services/configurationServices';


export const useCity = () => {  

    const [city, setCity] = useState([]);

    const getCity = (id) => {
        try {
              getCityDetails(id).then((resp) => {
                if (resp != undefined) {
                  if (resp.Status == "success") {
                    setCity(resp.Data)
                  } else {
                    setCity([])
                  }
                }
              })
            } catch (error) {
              console.error(error)
            }
    }

    return { city, setCity, getCity }
}